import "./IrrigationPoolServices.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import IrrigationHero from "./sections/IrrigationHero";
import IrrigationPoolPumpSolutions from "./sections/IrrigationPoolPumpSolutions";
import Areas from "./sections/Areas";
import UrgentService from "./sections/UrgentService";
import Services from "./sections/Services";
export default function IrrigationPoolServicesPage() {
  return <div>
      <Header />
      <IrrigationHero />
      <IrrigationPoolPumpSolutions />
      <Areas />
       <Services />
      <UrgentService />
     
      <Footer />
    </div>;
}